import { createContext } from "react"
import { MoveWorkareaOrGroupRequest } from "./List/dndModel"
import { GroupedWorkareas } from "./List/workareaGroupsListModel"
import { WorkareaGroupWithWorkareas } from "../../../domain/workareas/group"
import { Transaction } from "../../../domain/invoicing/transaction"
import { InvoicingSystem } from "../../../domain/invoicing/settings/invoicingSettings"

export type JobPlanSelection = undefined | {
  type: 'workarea' | 'group'
  workareaId?: number
  groupId?: string
}

export type JobPlanContextData = {
  currentSelection?: JobPlanSelection
  clearSelection: () => void
  selectWorkarea: (workareaId: number) => void
  selectGroup: (groupId: string) => void
  jobFinalPrice: number
  jobEstimatedHours: number
  moveWorkareaOrGroup: (result: MoveWorkareaOrGroupRequest) => void
  groupedWorkareaData: {
    workareas: GroupedWorkareas;
    workareaGroups: WorkareaGroupWithWorkareas[];
  }
  transactions: Transaction[]
  isTotalsCalculating: boolean
  setIsTotalsCalculating: (isTotalsCalculating: boolean) => void
  pendingAction?: () => void
  setPendingAction: (action?: () => void) => void
  invoicingSystem: InvoicingSystem
}

const JobPlanContext = createContext<JobPlanContextData>({
  clearSelection: () => { },
  selectWorkarea: () => { },
  selectGroup: () => { },
  jobFinalPrice: 0,
  jobEstimatedHours: 0,
  moveWorkareaOrGroup: () => { },
  groupedWorkareaData: {
    workareas: {},
    workareaGroups: []
  },
  transactions: [],
  isTotalsCalculating: false,
  setIsTotalsCalculating: () => { },
  pendingAction: undefined,
  setPendingAction: () => { },
  invoicingSystem: 'synkedUp'
})

export default JobPlanContext